/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopCanvasItem = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopCanvasItem model module.
   * @module model/WorkshopCanvasItem
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopCanvasItem</code>.
   * @alias module:model/WorkshopCanvasItem
   * @class
   */
  var exports = function() {
    var _this = this;













  };

  /**
   * Constructs a <code>WorkshopCanvasItem</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopCanvasItem} obj Optional instance to populate.
   * @return {module:model/WorkshopCanvasItem} The populated <code>WorkshopCanvasItem</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('ParticipantID')) {
        obj['ParticipantID'] = ApiClient.convertToType(data['ParticipantID'], 'Integer');
      }
      if (data.hasOwnProperty('PhaseID')) {
        obj['PhaseID'] = ApiClient.convertToType(data['PhaseID'], 'Integer');
      }
      if (data.hasOwnProperty('ItemTypeID')) {
        obj['ItemTypeID'] = ApiClient.convertToType(data['ItemTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Text')) {
        obj['Text'] = ApiClient.convertToType(data['Text'], 'String');
      }
      if (data.hasOwnProperty('GroupID')) {
        obj['GroupID'] = ApiClient.convertToType(data['GroupID'], 'Integer');
      }
      if (data.hasOwnProperty('X')) {
        obj['X'] = ApiClient.convertToType(data['X'], 'Number');
      }
      if (data.hasOwnProperty('Y')) {
        obj['Y'] = ApiClient.convertToType(data['Y'], 'Number');
      }
      if (data.hasOwnProperty('Width')) {
        obj['Width'] = ApiClient.convertToType(data['Width'], 'Number');
      }
      if (data.hasOwnProperty('Height')) {
        obj['Height'] = ApiClient.convertToType(data['Height'], 'Number');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Integer} ParticipantID
   */
  exports.prototype['ParticipantID'] = undefined;
  /**
   * @member {Integer} PhaseID
   * @default 0
   */
  exports.prototype['PhaseID'] = 0;
  /**
   * @member {Integer} ItemTypeID
   * @default 0
   */
  exports.prototype['ItemTypeID'] = 0;
  /**
   * @member {String} Text
   * @default ''
   */
  exports.prototype['Text'] = '';
  /**
   * @member {Integer} GroupID
   */
  exports.prototype['GroupID'] = undefined;
  /**
   * @member {Number} X
   * @default 0.0
   */
  exports.prototype['X'] = 0.0;
  /**
   * @member {Number} Y
   * @default 0.0
   */
  exports.prototype['Y'] = 0.0;
  /**
   * @member {Number} Width
   * @default 0.0
   */
  exports.prototype['Width'] = 0.0;
  /**
   * @member {Number} Height
   * @default 0.0
   */
  exports.prototype['Height'] = 0.0;
  /**
   * @member {Integer} CreatorID
   * @default 0
   */
  exports.prototype['CreatorID'] = 0;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


